import { render, staticRenderFns } from "./DataXjInfo.vue?vue&type=template&id=dbf3c1c2&scoped=true&"
import script from "./DataXjInfo.vue?vue&type=script&lang=js&"
export * from "./DataXjInfo.vue?vue&type=script&lang=js&"
import style0 from "./DataXjInfo.vue?vue&type=style&index=0&id=dbf3c1c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf3c1c2",
  null
  
)

export default component.exports